<template>
  <aside id="sidebar" class="sidebar">

    <ul class="sidebar-nav" id="sidebar-nav">
      <li
          v-for="item in menuItems"
          :key="item.path"
          class="nav-item"
      >
        <router-link
            :to="item.path"
            class="nav-link"
            :class="{ collapsed: !item.active }"
        >
          <i :class="item.icon"></i>
          <span>{{ item.title }}</span>
        </router-link>
      </li>
    </ul>

  </aside>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router';
import { computed } from 'vue';

const router = useRouter();
const route = useRoute();

const menuItems = computed(() => {
  const main = router.options.routes.find(r => r.component?.__name === 'MainLayout');
  if (!main || !main.children) {
    return [];
  }

  return main.children.filter(child => child.meta?.menu).map(child => ({
    path: '/' + child.path,
    title: child.meta.menu.name,
    icon: child.meta.menu.icon ?? 'bi bi-circle',
    active: route.path.startsWith('/' + child.path)
  }));
});
</script>

<style scoped>

</style>